import { LeftOutlineIcon } from '@carboncopyco/icons';
import { ArchiveEmptyStateIllustration } from '@carboncopyco/illustrations';
import { Button, EmptyView, TextBase } from '@carboncopyco/ui';
import { useNavigate } from 'react-router-dom';
import { useWorkspacePageProps } from './WorkspacePageContext';

export const WorkspacePageArchiveEmptyState = () => {
  const navigate = useNavigate();
  const { rootPath } = useWorkspacePageProps();
  return (
    <EmptyView
      illustration={<ArchiveEmptyStateIllustration />}
      title="No items have been archived yet"
      message={
        <div className="flex flex-col items-center gap-5 ">
          <TextBase label="Once you archive an item, it will appear here." />
          <Button
            blue
            link
            label="Back"
            leftIcon={<LeftOutlineIcon />}
            onClick={() => navigate(`${rootPath}/`)}
          />
        </div>
      }
    />
  );
};
